"use strict";

exports._ = exports._class_apply_descriptor_get = _class_apply_descriptor_get;
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);

    return descriptor.value;
}
